import React from "react";
import DueItem from "./DueItem";
import { Title, SubTitle } from "./StyledComponents";

const PendingDuesList = ({
    selectedDues,
    totalDuesAmount,
    isBookingPayment,
    enableDueSelection,
    onDueSelection,
    formatDateRange,
    duesLabelMapping
}) => {

    return (
        <div className="relative">
            <div className="bg-zinc-50 rounded-t-3xl px-6 pt-6 mt-[-20px] relative z-10">
                <div className="mb-4">
                    <Title>Pending Dues</Title>
                    <SubTitle>Please complete your payment</SubTitle>
                </div>
                {selectedDues.length > 0 && (
                    <div className="mb-4">
                        {selectedDues.map((due, index) => (
                            <DueItem
                                key={due.id}
                                due={due}
                                isBookingPayment={isBookingPayment}
                                enableDueSelection={enableDueSelection}
                                totalDuesAmount={totalDuesAmount}
                                onDueSelection={onDueSelection}
                                formatDateRange={formatDateRange}
                                duesLabelMapping={duesLabelMapping}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PendingDuesList;